import Header from "../components/Header";
import Hero from "../components/Hero";
import TrustStrip from "../components/TrustStrip";
import WhatIsSmartFilm from "../components/WhatIsSmartFilm";
import Products from "../components/Products";
import BeforeAfter from "../components/BeforeAfter";
import Benefits from "../components/Benefits";
import HowItWorks from "../components/HowItWorks";
import Pricing from "../components/Pricing";
import LeadForm from "../components/LeadForm";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <WhatIsSmartFilm />
        <Products />
        <BeforeAfter />
        <Benefits />
        <HowItWorks />
        <Pricing />
        <LeadForm />
        <Faq />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
